import React, { PureComponent } from 'react';
import { Button } from 'antd';
import { language } from '../../../language';
import { SelectTopic } from '../select-topic';

export class TopicSelector extends PureComponent<
    {
        value: any;
        contentConfig: Record<string, any>;
        modalConfig: Record<string, any>;
        onChange: (value: any) => void;
    },
    { visibleModal: boolean }
> {
    state = {
        visibleModal: false,
    };

    showModal = () => {
        this.setState({ visibleModal: true });
    };
    hideModal = () => {
        this.setState({ visibleModal: false });
    };
    onChange = (value) => {
        const { onChange } = this.props;
        this.hideModal();
        onChange(value);
    };

    render() {
        const {
            value: { linkParams },
            contentConfig,
            modalConfig,
        } = this.props;

        const { visibleModal } = this.state;
        const hasSingleTarget = linkParams && linkParams.name;
        const selectProps = {
            value: linkParams,
            onChange: this.onChange,
        };
        return (
            <span className="link-name">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {hasSingleTarget ? (
                        <span className="link-name-label">{linkParams.name}</span>
                    ) : (
                        '未选择'
                    )}
                    <Button type={'link'} onClick={this.showModal} className="link-type-edit">
                        {hasSingleTarget
                            ? language.getText('components.Tools.modify')
                            : language.getText('components.Tools.select')}
                    </Button>
                    <SelectTopic
                        contentConfig={contentConfig}
                        modalConfig={modalConfig}
                        showModal={visibleModal}
                        onCancel={this.hideModal}
                        {...selectProps}
                    />
                </div>
            </span>
        );
    }
}
